<script setup>
const businessStore = useBusinessStore();
const { business } = storeToRefs(businessStore);

const { t, locale } = useI18n();

const head = useLocaleHead({
  addDirAttribute: true,
  identifierAttribute: 'id',
  addSeoAttributes: true
});

const defaultTitle = computed(() => {
  if (!business.value) return "Bookforme";

  const businessName = business.value.name;
  return locale.value === "en" ? `${businessName} - Bookforme` : `Bookforme - ${businessName}`;
});

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${t('meta.' + titleChunk)} - ${defaultTitle.value}` : defaultTitle.value;
  },
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ]
});
</script>

<template>
  <Html :lang="head.htmlAttrs.lang" :dir="head.htmlAttrs.dir">
  <Head>
    <template v-for="link in head.link" :key="link.id">
      <Link :id="link.id" :rel="link.rel" :href="link.href" :hreflang="link.hreflang" />
    </template>
    <template v-for="meta in head.meta" :key="meta.id">
      <Meta :id="meta.id" :property="meta.property" :content="meta.content" />
    </template>
  </Head>
  <Body>
  <NuxtLoadingIndicator color="#2E83FB" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <UNotifications />
  <UModals />
  </Body>
  </Html>
</template>

<style>
/* ######### for pages transition ######### */

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.2s;
}

.slide-left-enter-from {
  opacity: 0;
  transform: translate(50px, 0);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translate(-50px, 0);
}

.slide-right-enter-from {
  opacity: 0;
  transform: translate(-50px, 0);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translate(50px, 0);
}
</style>
